import React from 'react';

const Play = () => (
  <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.0664 9.29058L0.820749 18.1784L0.82075 0.402778L16.0664 9.29058Z" fill="#1A1A1A" />
  </svg>
);

export default Play;
